<template>
    <div class="tab-content">
        <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
            <el-tab-pane :disabled="!businessUnitPermission.viewDetail" :label="$t('bu_tab_info_detail')" name="first">
                <el-card v-if="projectInfo" class="box-card card panel">
                    <el-row class="info-title-color">
                      <el-col :span="11">
                        <div class="title">{{$t('bu_tab_info_detail_bu')}}</div>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('bu_tab_info_detail_createdBy')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                              </div>
                              <!--<span class="pointer" v-if="projectInfo.managerUser" @mouseenter="getUserInfo(projectInfo.managerUser.id)">{{projectInfo.managerUser.user.fullName}}</span>-->
                              <span class="pointer" v-if="projectInfo.creatorUser" @mouseenter="getUserInfo(projectInfo.creatorUser.id)">{{projectInfo.creatorUser.user.fullName}}</span>
                            </el-tooltip>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/no.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('bu_tab_info_detail_no')}}:
                          </el-col>
                          <el-col :span="14">
                            <el-row class="info-color">
                              <el-col :span="24">{{projectInfo.code}}</el-col>
                            </el-row>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('bu_tab_info_detail_name')}}:
                          </el-col>
                          <el-col :span="14">
                            <el-row class="info-color">
                              <el-col :span="24">
                                <strong>{{projectInfo.name}}</strong>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_email')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.email}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_businessUnits_phone')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.phone}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/case.svg" width="20px;" style="margin-right: 5px;">
                            <span>{{$t('modal_businessUnits_extension')}}:</span>
                          </el-col>
                          <el-col :span="14" class="info-color">
                            {{projectInfo.phone2}}
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('bu_tab_info_detail_profitCentre')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                               <span>{{projectInfo.profitCentre ? 'Yes' : 'No'}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/dollar-sign.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('bu_tab_info_detail_bilingMethod')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.bill == 0 && projectInfo.profitCentre">{{$t('modal_billing_single')}}</span>
                              <span v-if="projectInfo.bill == 1 && projectInfo.profitCentre">{{$t('modal_billing_progress')}}</span>
                            </el-col>
                        </el-row>

                        <el-row  style="margin-bottom: 5px;">
                          <el-col :span="10" class="h-center">
                            <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                            {{$t('bu_tab_info_detail_buManager')}}
                          </el-col>
                          <el-col :span="14" class="info-color">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                              </div>
                              <span class="pointer" v-if="projectInfo.managerUser" @mouseenter="getUserInfo(projectInfo.managerUser.id)">{{projectInfo.managerUser.user.fullName}}</span>
                            </el-tooltip>
                          </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('bu_tab_info_detail_businessCentre')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.businessCenterList">{{projectInfo.businessCenterList}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>Warehouses:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.buWarehouses">{{projectInfo.buWarehouses}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('bu_tab_info_detail_engagements')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.buEngagements">{{projectInfo.buEngagements}}</span>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom: 5px;">
                            <el-col :span="10" class="h-center">
                                <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                <span>{{$t('bu_tab_info_detail_projects')}}:</span>
                            </el-col>
                            <el-col :span="14" class="info-color">
                              <span v-if="projectInfo.buProjects">{{projectInfo.buProjects}}</span>
                            </el-col>
                        </el-row>

                        <el-divider></el-divider>

                        <div class="title">{{$t('bu_tab_info_detail_notifications')}}</div>

                        <el-divider></el-divider>

                      </el-col>
                      <el-col :span="13">
                        <!-- <div class="title" style="text-align: center;">{{$t('bu_tab_info_detail_progress')}}</div> -->

                        <el-row type="flex" justify="end">
                          <el-col :span="8">
                            <br>
                            <!-- <el-row>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <el-tooltip class="item" effect="dark" content="Stage" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.companyStage.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24" style="margin-bottom: 15px;">
                                <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.projectStatus.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="24">
                                <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                  <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="projectInfo.priority.name"></el-tag>
                                </el-tooltip>
                              </el-col>
                            </el-row> -->
                          </el-col>
                          <el-col :span="8">
                            <div class="title">{{$t('bu_tab_info_detail_progress')}}</div>

                            <!-- <el-progress type="dashboard" :percentage="Math.round(projectInfo.progress)" :color="colors"></el-progress> -->
                            <div style="margin-bottom: 15px;">
                                <!-- <div class="circle">
                                    <div class="circle_number">{{projectInfo.doneChildTasksCount}}/{{projectInfo.childTasksCount}}</div>
                                </div> {{$t('general_done')}}/{{$t('general_subTask')}} -->

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.childTasksCount}} - {{$t('general_subTask')}}</el-col>
                                </el-row>

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.fullProgressTasksCount}} - 100%</el-col>
                                </el-row>

                                <el-row :gutter="20">
                                  <el-col :span="24" :offset="0">{{projectInfo.doneChildTasksCount}} - {{$t('general_done')}}</el-col>
                                </el-row>

                                <!-- <div>{{$t('general_done')}} ({{projectInfo.doneChildTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                            </div>
                            <div>
                                <!-- <div class="circle">
                                    <div class="circle_number">{{projectInfo.fullProgressTasksCount}}/{{projectInfo.childTasksCount}}</div>
                                </div> 100%/{{$t('general_subTask')}} -->

                                <!-- <div>100% ({{projectInfo.fullProgressTasksCount}}) / {{$t('general_subTask')}} ({{projectInfo.childTasksCount}})</div> -->
                            </div>
                          </el-col>
                          <el-col :span="8">
                            <br>
                            <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                    <!-- <div class="panel__description">
                      <div class="panel__gif">
                        <img src="@/assets/img/gif.gif" width="20px;">
                      </div>
                      <el-collapse>
                        <el-collapse-item :title="$t('bu_tab_info_detail_about') + ':'" name="1">
                          <div v-html="!projectInfo.description ? emtyDescription : projectInfo.description"></div>
                        </el-collapse-item>
                      </el-collapse>
                    </div> -->

                    <div class="panel__footer">
                      <div class="panel__team">

                        <el-row :gutter="20">
                          <el-col :span="14" :offset="0">
                            <div class="panel__team_title">
                              <i class="color h-center">
                                <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                <div class="title">{{$t('bu_tab_info_detail_businessUnitTeam')}}:</div>
                                <!-- {{$t('bu_tab_info_detail_businessUnitTeam')}}: -->
                              </i>
                            </div>
                            <div>
                              <div class="panel__team_item" v-for="item in businessUnitCompanyUserList" :key="item.id" >
                                <el-tooltip placement="top">
                                  <div slot="content">
                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                  </div>
                                  <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                </el-tooltip>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="10" :offset="0">
                            <div class="title">{{$t('bu_tab_info_detail_permissions')}}:</div>
                            <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in businessUnitCompanyUserList" :key="item.id">
                              <div>{{item.permissionPreset}}</div>
                            </div>
                          </el-col>
                        </el-row>

                      </div>
                      <div class="panel__clients">
                        <div class="panel__team_title">
                          <i class="color h-center">
                            <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                            <div class="title">{{$t('bu_tab_info_detail_businessUnitClients')}}:</div>
                            <!-- {{$t('bu_tab_info_detail_businessUnitClients')}}: -->
                          </i>
                        </div>
                        <div>
                          <div class="panel__team_item" v-for="item in businessUnitCompanyClientList" :key="item.id">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="item.companyClient.name">Name: {{item.companyClient.name}}<br/></span>
                                <span v-if="item.companyClient.phone">Phone: {{item.companyClient.phone}}<br/></span>
                                <span v-if="item.companyClient.street">Location: {{item.companyClient.street}}<br/></span>
                                <span v-if="item.companyClient.email">Email: {{item.companyClient.email}}<br/></span>
                                <span v-if="item.companyClient.fax">Fax: {{item.companyClient.fax}}<br/></span>
                                <span v-if="item.companyClient.website">Website: <a :href="item.companyClient.website" target="_blank">{{item.companyClient.website}}</a><br/></span>
                                <span v-if="item.companyClient.facebook">Facebook: <a :href="item.companyClient.facebook" target="_blank">{{item.companyClient.facebook}}</a><br/></span>
                                <span v-if="item.companyClient.linkedin">Linkedin: <a :href="item.companyClient.linkedin" target="_blank">{{item.companyClient.linkedin}}</a><br/></span>
                              </div>
                              <span v-html="item.companyClient.name"></span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                      <div class="panel__vendors">
                        <div class="panel__team_title">
                          <i class="color h-center">
                            <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                            <div class="title">{{$t('bu_tab_info_detail_businessUnitVendors')}}:</div>
                            <!-- {{$t('bu_tab_info_detail_businessUnitVendors')}}: -->
                          </i>
                        </div>
                        <div>
                          <div class="panel__team_item" v-for="item in businessUnitCompanyVendorList" :key="item.id">
                            <el-tooltip placement="top">
                              <div slot="content">
                                <span v-if="item.companyVendor.name">Name: {{item.companyVendor.name}}<br/></span>
                                <span v-if="item.companyVendor.phone">Phone: {{item.companyVendor.phone}}<br/></span>
                                <span v-if="item.companyVendor.street">Location: {{item.companyVendor.street}}<br/></span>
                                <span v-if="item.companyVendor.email">Email: {{item.companyVendor.email}}<br/></span>
                                <span v-if="item.companyVendor.fax">Fax: {{item.companyVendor.fax}}<br/></span>
                                <span v-if="item.companyVendor.website">Website: <a :href="item.companyVendor.website" target="_blank">{{item.companyVendor.website}}</a><br/></span>
                                <!-- <span v-if="item.companyVendor.facebook">Facebook: {{item.companyVendor.facebook}}<br/></span>
                                <span v-if="item.companyVendor.linkedin">Linkedin: {{item.companyVendor.linkedin}}<br/></span> -->
                              </div>
                              <span v-html="item.companyVendor.name"></span>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                    </div>

                </el-card>
            </el-tab-pane>

            <!-- about -->
            <el-tab-pane :disabled="!businessUnitPermission.viewAbout" :label="$t('bu_tab_info_about')" name="about">
              <el-card class="box-card card panel">
                <!-- <div v-html="!projectInfo.description ? emtyDescription : projectInfo.description"></div> -->
                <about/>
              </el-card>
              <!-- (About project) -->
            </el-tab-pane>

            <!-- to do -->
            <!-- <el-tab-pane :disabled="!businessUnitPermission.viewToDo" :label="$t('bu_tab_info_toDo')" name="toDo">
              <el-card class="box-card card panel">
                Current Service Under Development
              </el-card>
            </el-tab-pane> -->

            <!-- history -->
            <el-tab-pane :disabled="!businessUnitPermission.viewHistory" :label="$t('bu_tab_info_history')" name="five">
            <businessUnitHistory/>
            </el-tab-pane>

            <!-- Warehouses -->
            <el-tab-pane :disabled="!businessUnitPermission.viewHistory" label="Warehouses" name="warehouses">
              <BusinessUnitWarehouses ref="warehouses"/>
            </el-tab-pane>

            <!-- engagements -->
            <el-tab-pane :label="$t('bu_tab_info_engagements')" name="six">
            <businessUnitEngagements
                v-if="value === 'six'"
                ref="businessUnitEngagementsTab"/>
            </el-tab-pane>

            <el-tab-pane :label="$t('bu_tab_info_projects')" name="seven">
              <businessUnitProjects ref="businessUnitProjectTab" v-if="value === 'seven'"/>
            </el-tab-pane>

            <!-- permissions -->
            <el-tab-pane v-if="companyLayout.permission.managePermissionBusinessUnit" :label="$t('bu_tab_info_permissions')" name="permissions">
              <businessUnitPermissionTab @setNewPermissions="setNewPermissions" ref="businessUnitPermissionTab" :permissionsList="permissionsList" :pressetsList="pressetsList"/>
            </el-tab-pane>
        </el-tabs>
<!--      <div  class="book-mark-block pointer">-->
<!--        <div>-->
<!--          <div v-if="bookmarkListBusinessUnit.info" @click="changeBookMarkBusinessUnit(bookmarkListBusinessUnit.info, $route.query.companyId, selectedRow.businessUnitId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--          <div v-else @click="changeBookMarkBusinessUnit(bookmarkListBusinessUnit.info, $route.query.companyId, selectedRow.businessUnitId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
</template>

<script>
    import axios from 'axios';
    import businessUnitHistory from '@/components/BusinessUnits/businessUnitHistoryTab.vue'
    import BusinessUnitWarehouses from '@/components/BusinessUnits/BusinessUnitWarehouses.vue'
    import businessUnitEngagements from '@/components/BusinessUnits/businessUnitEngagements.vue'
    import businessUnitProjects from '@/components/BusinessUnits/businessUnitProjects.vue'
    import moment from 'moment'
    import businessUnitPermissionTab from '@/components/BusinessUnits/permissions/businessUnitPermissionTab.vue'
    import about from '@/components/BusinessUnits/about/about.vue'

    export default  {
        name: 'BuInfoTab',
        beforeMount() {

        },
        mounted(){

        },
        components: {
            businessUnitHistory,
            businessUnitEngagements,
            businessUnitProjects,
            businessUnitPermissionTab,
            about,
            BusinessUnitWarehouses,
        },
        props: [
            'activeInfoTab',
            'value',
            'activeProjectId',
            'projectInfo',
            // 'bookmarkListBusinessUnit',
            'selectedRow',
            'companyLayout',
            'businessUnitPermission'
        ],
        computed: {

        },
        data() {
            return {
              tooltipUser:{},
                // Business Unit
                businessUnitCompanyUserList: null,
                businessUnitCompanyClientList: null,
                businessUnitCompanyVendorList: null,
                moment:moment,
                emtyDescription: this.$i18n.t('noDetailsProvided'),
                colors: [
                  {color: '#e67112', percentage: 25},
                  {color: '#63B8FF', percentage: 51},
                  {color: '#63B8FF', percentage: 76},
                  {color: '#0fd641 ', percentage: 100}
                ],
              //permissions
              permissionsList: [],
              pressetsList: [],
            }
        },
        watch: {
            projectInfo: function (val) {
                this.businessUnitCompanyUserList = this.projectInfo.businessUnitCompanyUserList
                this.businessUnitCompanyClientList = this.projectInfo.businessUnitCompanyClientList
                this.businessUnitCompanyVendorList = this.projectInfo.businessUnitCompanyVendorList
            }
        },
        methods:{
          getUserInfo(id){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/businessUnits/fieldInfo?companyId=${this.$route.query.companyId}&field=companyUser&companyUserId=${id}`)
                    .then(response => {
                      this.tooltipUser = response.data.fieldInfo.user
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                    });
          },
          notification(title, message, type) {
            this.$notify({
              title: title,
              message: message,
              type: type
            });
          },
          // changeBookMarkBusinessUnit(state, companyId, businessUnitId, taskId){
          //   let data = this.bookmarkListBusinessUnit
          //   data.info = !this.bookmarkListBusinessUnit.info
          //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          //   axios.post(`/api/v1/bookmarks/setBusinessUnit?companyId=${companyId}&businessUnitId=${businessUnitId}`, data)
          //           .then(response => {
          //             if (this.bookmarkListBusinessUnit.info) {
          //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
          //             } else {
          //               this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
          //             }
          //           })
          //           .catch(error => {
          //           });
          // },
          handleClick(tab, event) {
              if(tab.name === "six") {
                this.$store.dispatch('getBusinessUnitEngagementList', this.$route.query.businessUnitId);
                // console.log('this.$refs.businessUnitEngagementsTab', this.$refs.businessUnitEngagementsTab)
                // this.$nextTick(() => {
                //   this.$refs.businessUnitEngagementsTab.getCodesList()
                // })
              }

              if(tab.name === "seven") {
                this.$store.dispatch('getBusinessUnitProjectsList', this.$route.query.businessUnitId);
              }
            // permissions
              if(tab.name === "permissions") {
                this.$store.dispatch('getBusinessUnitPermissionsList', this.$route.query.businessUnitId);
                this.loadPermissionData()
              }

              if (tab.name === 'five'){
                this.$store.dispatch('getBusinessUnitHistory');
              }

              if (tab.name === 'warehouses'){
                this.$refs.warehouses.openTab()
              }

              if (tab.name === 'about') {
                this.$store.dispatch('about', 'bu')
              }
          },
          async loadPermissionData(){
            try {
              this.permissionsList = await this.getPermissionsRulesList();
              this.pressetsList = await this.getPermisssionsPressetsList()
            } catch(err){
              console.log(err)
            }
          },
          getPermissionsRulesList(){
            return new Promise ((resolve, reject) => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                      .get(`/api/v1/permissionRules/list?permissionGroup=3`)
                      .then(response => {
                        console.log('---', response.data);
                        resolve(response.data.list);
                        loader.hide()
                      })
                      .catch(error => {
                        loader.hide();
                        console.log('An error occurred:', error);
                      });
            })
          },
          getPermisssionsPressetsList(){
            return new Promise ((resolve, reject) => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                      .get(`/api/v1/permissionPressets/list?permissionGroup=3&companyId=${this.$route.query.companyId}`)
                      .then(response => {
                        const customPresset = {
                          companyId: 0,
                          id: 0,
                          permissionGroup: 3,
                          permissionPressetIdArr: [],
                          permissionPressetName: "customPresset"
                        };
                        response.data.list.push(customPresset);
                        resolve(response.data.list)
                        loader.hide()
                      })
                      .catch(error => {
                        loader.hide();
                        console.log('An error occurred:', error);
                      });
            })
          },
            setNewPermissions(permissions){
              this.$emit('setNewPermissions', permissions)
            }
        }
    }
</script>

<style lang="less" scoped>
    .about-task{
        display:none;
    }
    .about-task.open{
        display:block;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        display:flex;
        align-items:center;
        font-weight:bold;
        padding:10px;
        font-size:14px;
        transition: .5s;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
    .card {
        .slot{
            margin:10px 0 0 0;
            padding-bottom:10px;
            border-bottom: 1px solid #ccc;
        }
        margin-bottom: 20px;
        .tag {
            margin-right: 5px;
        }
        &__no {
            display: flex;
            justify-content:space-between;
            /*align-items: center;*/
            font-weight: bold;
            padding-bottom: 5px;
            .name {
                margin-right: 10px;
            }
            .progress {
                flex: 1;
            }
        }
        &__name {
            font-weight: bold;
            padding-bottom: 5px;
        }
        &__task-name {
            font-size: 18px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
        }
        &__location {
            padding-top: 5px;
            padding-bottom: 5px;
        }
        &__stat {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__by-to {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__btn {
            align-self: flex-end;
            // padding-top: 5px;
            // padding-bottom: 5px;
            // text-align: right;
            margin-left: 10px;
        }
    }

    .panel {
      min-width: 890px;
      margin-bottom: 20px;

      i.color {
          font-style: normal;
          color: #888
        }

      // Header
      &__header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
      }

      &__project-name {
        span {font-weight: bold;}
      }
      &__task-name {
        font-weight: bold;
        font-size: 20px;
      }
      &__progress {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 5px;
        .el-progress {
          width: 350px;
        }
      }
      &__stage {
          min-width: 70px;
      }
      &__status {
        display: flex;
        justify-content: flex-end;
      }

      // Info
      &__info {
        // border-bottom: 1px solid #EBEEF5;
        padding: 10px 0 5px 0;
        position: relative;
      }
      &__date {
        display: flex;
        margin-bottom: 5px;
      }
      &__planned {
        width: 300px;
        span {font-weight: bold;}
      }
      &__actual {
        span {font-weight: bold;}
        i {font-style: normal;}
      }
      &__by-to {
        display: flex;
      }
      &__by {
        width: 300px;
        span {font-weight: bold;}
      }
      &__to {
        span {font-weight: bold;}
      }
      &__priority {
        position: absolute;
        top: calc(50% - 10px);
        right: 0;
      }

      // Description
      &__description {
        position: relative;
        // border-bottom: 1px solid #EBEEF5;
        padding: 5px 0;
      }

      &__gif {
        position: absolute;
        top: 18px;
        left: 0;
      }

      // Footer
      &__footer {
        display: flex;
        justify-content: space-between;
        min-height: 150px;
        padding: 5px 0;
      }
      &__team {
        width: 46%;
        padding: 0 10px 0 0;
        border-right: 1px solid #EBEEF5;
        &_title {
          // font-weight: bold;
          font-size: 16px;
        }
        &_item {
          cursor: pointer;
          margin-left: 25px;
          line-height: 1.5;
          // color: #4277A6;
          color: black;
        }
      }
      &__clients {
        width: 27%;
        padding: 0 10px;
        border-right: 1px solid #EBEEF5;
        &_title {
          font-weight: bold;
        }
        &_item {
          cursor: pointer;
          margin-left: 22px;
        }
      }
      &__vendors {
        width: 27%;
        padding: 0 0 0 10px;
        &_title {
          font-weight: bold;
        }
        &_item {
          cursor: pointer;
          margin-left: 22px;
        }
      }

      // &__project-name {
      //   font-weight: bold;
      // }
      // &__task-name {
      //   font-size: 18px;
      //   padding-bottom: 5px;
      // }
      // &__location {
      //   padding-bottom: 5px;
      // }
      // &__created-by {
      //   padding-bottom: 5px;
      // }
      // &__about {
      //   padding-bottom: 5px;
      // }
      // &__by-to {
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      // }
      // &__progress {
      //   display: flex;
      //   justify-content: space-between;
      //   align-items: center;
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      //   .el-progress {
      //     flex-grow: 1;
      //     // width: 200px;
      //   }
      //   div {
      //     white-space: nowrap;
      //     margin-right: 10px;
      //     &:last-child {
      //       margin-right: 0;
      //     }
      //   }
      // }
      // &__date {
      //   padding-bottom: 5px;
      //   span {
      //     font-weight: bold;
      //   }
      //   i {
      //     font-style: normal;
      //   }
      // }
      // &__status {
      //   padding-bottom: 5px;
      // }
      // &__slot {
      //   padding-bottom: 5px;
      //   &:first-child {
      //     margin-top: 20px;
      //   }
      //   span {
      //     font-weight: bold;
      //   }
      // }
    }
    .vendor{
      font-weight:bold;
    }
    p {
      img {
        max-width: 100%;
      }
    }
</style>
